const badges = [
  {
    icon: "ri-calendar-check-line",
    title: "30 días",
    desc: "de transformación real",
  },
  {
    icon: "ri-stack-line",
    title: "5 módulos",
    desc: "paso a paso",
  },
  {
    icon: "ri-shield-check-line",
    title: "7 días",
    desc: "de garantía",
  },
  {
    icon: "ri-flashlight-line",
    title: "Acceso inmediato",
    desc: "desde cualquier dispositivo",
  },
];

export default function TrustBadges() {
  return (
    <section style={{ backgroundColor: "#0D0D0D" }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8 py-14 md:py-20">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8">
          {badges.map((badge, index) => (
            <div
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-lg mb-4 border border-gold/30 group-hover:border-gold/60 transition-colors duration-300">
                <i className={`${badge.icon} text-gold text-xl md:text-2xl`} />
              </div>
              <h3 className="font-serif text-lg md:text-xl text-cream mb-1">
                {badge.title}
              </h3>
              <p className="font-sans text-xs md:text-sm text-cream/50">
                {badge.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
      {/* Divider */}
      <div className="h-px bg-gold-gradient" />
    </section>
  );
}